let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    /* P27-3: one listener's failure never silences the ones after it (the bag's meter, the counted icons, the page's re-sync) */
    subscribers[eventName].forEach((callback) => {
      try {
        callback(data);
      } catch (error) {
        console.error(error);
      }
    });
  }
}
